module.exports = __webpack_public_path__ + "media/images/carousel/banner_7-0c053bab8fb776d143e48be894bdd696.jpg";